import { render, staticRenderFns } from "./CourseCalendarEventPage.vue?vue&type=template&id=e5a35412"
import script from "./CourseCalendarEventPage.vue?vue&type=script&lang=js"
export * from "./CourseCalendarEventPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports